import {
  newDate,
  strIndex
} from '@/sui/data/flatten/tools'

import {
  episodAge,
  addMO,
  episodDays,
  divDuration,
  unitType
} from '@/sui/data/flatten/common'

function createExportedInfections (p, i, v) {
  const result = {
    type: i
  }

  result.year = p.year
  result.surv_id = p.surv
  result.prot = p.prot
  result.finess = p.estb.c
  result.etab = p.estb.n
  result.unit_type = unitType(p.year, p.uf.ufType)
  result.uf = p.uf.name
  result.sheet_id = p.sheet.id
  result.sheet_ver = p.sheet.ver

  result.pat_birthdate = newDate(p.pat.birthdate)
  result.pat_age_years = episodAge(p.pat, p.inf)
  result.pat_age_days = episodDays(p.pat, p.inf)
  result.pat_sex = p.pat.sex
  result.pat_entry = newDate(p.pat.entry)
  result.pat_origin = p.pat.origin
  result.pat_immuno = p.pat.immuno
  result.pat_trauma = p.pat.trauma
  result.pat_diagnosis = p.pat.diagnosis
  result.pat_antibio = p.pat.antibio
  result.pat_portage_bmr_bhre = p.pat.portageBmrBhre
  result.pat_severity_code = p.pat.mainSeverity.code
  result.pat_severity_value = p.pat.mainSeverity.value
  result.pat_mix_managment = p.pat.mixManagment
  result.pat_birth_weight = p.pat.birthWeight
  result.pat_gestational_age = p.pat.gestationalAge
  result.pat_cancer = p.pat.cancer
  result.pat_dead = p.pat.dead
  result.pat_death = newDate(p.pat.death)

  if (i === 'bact') {
    result.type = p.type
    result.inf_entrance = p.inf.entrance_v2
    result.inf_episod = newDate(p.inf.episod)
    result.inf_diagDate = newDate(p.inf.diagDate)
    result.inf_origin = p.inf.origin
    result.inf_lipids = p.inf.lipids
    if (v >= 3) {
      result.inf_prev_manip = p.inf.previousManip
      result.inf_prev_manip_type = p.inf.previousManipType
      result.inf_prev_manip_date = newDate(p.inf.previousManipDate)
    }
    result.inf_divDiag = p.inf.divDiag
    result.inf_neoDivDiag = p.inf.neoDivDiag
    if (v >= 3) {
      result.inf_clinical_signs = p.inf.clinicalSigns
      result.inf_bio_signs = p.inf.bioSigns
      result.inf_adapted_antibio = p.inf.adaptedAntibio
      result.inf_two_hemocs = p.inf.twoHemocs
    }
    result.inf_covidStatus = p.inf.covidStatus
    result.inf_kt_insertion = newDate(p.inf.insertion)
    result.inf_kt_insertionSite = p.inf.insertionSite
    result.inf_kt_removal = newDate(p.inf.removal)
    result.inf_kt_removed = p.inf.removed
    result.inf_kt_duration = divDuration(
      p, p => p.inf.insertion, [p => p.inf.removal, p => p.pat.death]
    )
    result.inf_a13_catheter = p.inf.catheter
    result.inf_a13_catheterType = p.inf.catheterType_v2
    result.inf_a3_intubated = p.inf.bactintubated
    result.inf_a3_intubStart = newDate(p.inf.bactintubStart)
    result.inf_a3_intubEnd = newDate(p.inf.bactintubEnd)
    result.itb_a3_intubDuration = divDuration(
      p, p => p.inf.bactintubStart, [p => p.inf.bactintubEnd, p => p.pat.death]
    )

    result.inf_a4_urinaryPresent = p.inf.urinaryPresent
    result.inf_a4_urinaryType = (v === 2) ? p.inf.urinary : p.inf.urinary_v2
    result.inf_a4_urinaryDiag = p.inf.urinaryDiag
    result.inf_a4_urinaryStart = newDate(p.inf.urinaryStart)
    result.inf_a4_urinaryRemoved = p.inf.urinaryRemoved
    result.inf_a4_urinaryEnd = newDate(p.inf.urinaryEnd)

    result.delay_insertion_episod = divDuration(
      p.inf, p => p.insertion, [ p => p.episod ]
    )
    result.delay_a3_intub_episod = divDuration(
      p.inf, p => p.bactintubStart, [ p => p.episod ]
    )
    result.delay_a4_urinary_episod = divDuration(
      p.inf, p => p.urinaryStart, [ p => p.episod ]
    )
  } else if (i === 'pneu') {
    result.inf_entrance = p.inf.entrance_v2
    result.itb_ecmo = p.itb.ecmo
    result.itb_intubated = p.itb.intubated
    result.itb_intubStart = newDate(p.itb.intubStart)
    result.itb_reintubated = p.itb.reintubated
    result.itb_intubEnd = newDate(p.itb.intubEnd)
    result.itb_intubDuration = divDuration(
      p, p => p.itb.intubStart, [p => p.itb.intubEnd, p => p.pat.death]
    )
    result.inf_origin = p.inf.origin
    result.inf_episod = newDate(p.inf.episod)
    result.inf_diagDate = newDate(p.inf.diagDate)
    result.inf_diagnosis = p.inf.diagnosis
    result.inf_covidStatus = p.inf.covidStatus
    result.delay_intub_episod = divDuration(
      p, p => p.itb.intubStart, [ p => p.inf.episod ]
    )
    result.delay_intubEnd_episod = divDuration(
      p, p => p.itb.intubEnd, [ p => p.inf.episod ]
    )
  }

  result.delay_episod_entry = divDuration(
    p, p => p.pat.entry, [ p => p.inf.episod ]
  )
  p.inf.microOrganisms.forEach(
    (mo, i) => {
      addMO(`inf_mo${strIndex(i + 1)}`, result, mo, v >= 3, v >= 5 ? 'v2' : 'v1')
    }
  )

  return result
}

function getInfectionsColumns (data) {
  const names = []
  var mos = []
  data.forEach(r =>
    Object.keys(r).forEach(k => {
      if (names.indexOf(k) === -1 && !k.includes('inf_mo')) {
        names.push(k)
      }
      if (mos.indexOf(k) === -1 && k.includes('inf_mo')) {
        mos.push(k)
      }
    })
  )
  mos = mos.sort()
  mos.forEach(mo => names.push(mo))
  const columns = []
  names.forEach(
    n => {
      columns.push({ header: n.replace(/_[0-9][0-9]_/g, '_'), key: n })
    }
  )
  return columns
}

export default {
  createExportedInfections: createExportedInfections,
  getInfectionsColumns: getInfectionsColumns
}
